/**
 * Ryan O'Dowd
 * 2024-09-22
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    chapterNumbersWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      flexWrap: 'wrap',
      gap: 4,
    },
    chapterNumber: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'flex-start',
      width: globalScale * 52, // @TODO: needs to match ProgressIndicator size
      height: globalScale * 52, // @TODO: needs to match ProgressIndicator size
      backgroundColor: 'transparent',
      borderRadius: globalScale * 26, // @TODO: needs to match ProgressIndicator size / 2
      margin: globalScale * 4,
      padding: globalScale * 0,
    },
    chapterNumberText: {
      color: colors.white,
      fontSize: globalScale * 20,
    },
    chapterAndMetadataWrapper: {
      display: 'flex',
    },
    selectedChapterAndMetadataWrapper: {
      width: '100%',
      flexDirection: 'row',
    },
    currentBookChapterReadingWrapper: {
      borderColor: colors.qqq,
      borderWidth: globalScale * 2,
      borderRadius: globalScale * 12,
      margin: globalScale * -2, // must match borderWidth
      padding: globalScale * 0,
      backgroundColor: `${colors.qqq}88`,
    },
    chapterMetadata: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    instructionsText: {
      display: 'flex',
      flexWrap: 'wrap',
      alignSelf: 'center',
      fontSize: 16,
      color: colors.white,
      marginBottom: 8,
      marginRight: 116, // @TODO: dynamic
    },
    versesWrapper: {
      display: 'flex',
      width: '100%',
    },
    selectedChapter: {
      backgroundColor: 'transparent',
    },
    completedChapter: {
      backgroundColor: colors.completeBg,
    },
    selectedChapterText: {
      color: colors.white,
      fontSize: 20,
    },
  };
};

export default getStyles;
